module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/trekking.ae625dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/trekking.jpg
// module id = tYTy
// module chunks = 0